
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
data (){
return {

}
},
components:{
Flexbox,
FlexboxItem
},
beforeMount(){
if(this.$router.history.current.path == "/fleaSendStatus"){
document.title = "审核列表";
}
},
methods:{

}
}



// WEBPACK FOOTER //
// ./src/components/fleaMarketComponents/fleaSendStatus.vue